// extracted by mini-css-extract-plugin
module.exports = {"detail":"book-detail_detail__5jlIj"};